// src/components/Footer.jsx
import { useNavigate, useLocation } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '/home';

  const scrollTo = (hash) => {
    if (isHome) {
      document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/' + hash);
    }
  };

  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: '1.5rem' }}>
              <div style={{ width: 40, height: 40, borderRadius: '50%', overflow: 'hidden', boxShadow: '0 4px 12px rgba(255,183,0,0.25)' }}>
                <img src="/images/logo.jpeg" alt="WACEAS" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.parentElement.innerHTML = '👩‍👧'; }} />
              </div>
              <h4 style={{ color: 'white' }}>WACEAS</h4>
            </div>
            <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '1.5rem', lineHeight: 1.7 }}>{t('footer.about')}</p>
            <div className="social-links">
              <a href="#" className="social-link" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="#" className="social-link" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="#" className="social-link" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
            </div>
          </div>

          <div>
            <h5>{t('footer.quick')}</h5>
            <ul className="footer-links">
              {[['nav.home','#home'],['nav.about','#about'],['nav.mission','#mission'],['nav.team','#team'],['nav.contact','#contact']].map(([k,h]) => (
                <li key={k}><button onClick={() => scrollTo(h)} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)', cursor: 'pointer', fontSize: '0.9375rem', fontFamily: 'Inter,sans-serif', transition: 'var(--transition)', padding: 0 }} onMouseOver={e => e.target.style.color='var(--primary)'} onMouseOut={e => e.target.style.color='rgba(255,255,255,0.7)'}>{t(k)}</button></li>
              ))}
            </ul>
          </div>

          <div>
            <h5>{t('footer.resources')}</h5>
            <ul className="footer-links">
              {[['footer.links.reports'],['footer.links.news'],['footer.links.gallery'],['footer.links.downloads']].map(([k]) => (
                <li key={k}><a href="#" onClick={e => e.preventDefault()}>{t(k)}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <h5>{t('footer.contact')}</h5>
            <ul className="footer-links">
              <li><a href="tel:+237682292807">+237 682 292 807</a></li>
              <li><a href="mailto:waceassociation@gmail.com">Email Us</a></li>
              <li><a href="https://wa.me/237699065019" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>{t('footer.copyright')}</p>
          <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
            <a href="#" onClick={e => e.preventDefault()}>{t('footer.privacy')}</a>
            <a href="#" onClick={e => e.preventDefault()}>{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
